import React from 'react'
import styled, { css } from 'styled-components'
import { color } from 'utils'

type RadioButtonProps = {
  checked: boolean
}

const RadioInput = styled.input`
  position: absolute;
  visibility: hidden;
`

const Check = styled.div`
  display: block;
  position: absolute;
  border: 2.5px solid ${color('dark600')};
  border-radius: 100%;
  height: 24px;
  width: 24px;
  z-index: 5;

  &:hover {
    border: 2.5px solid ${color('blue600')};
  }

  &:before {
    display: block;
    position: absolute;
    content: '';
    border-radius: 100%;
    height: 14px;
    width: 14px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
`

const RadioButtonWrapper = styled.div<{ checked: boolean }>`
  width: 24px;
  height: 24px;
  position: relative;

  ${({ checked }) =>
    checked &&
    css`
      input[type='radio'] ~ ${/* sc-selector */ Check} {
        border: 2.5px solid ${color('blue600')};
      }

      input[type='radio'] ~ ${/* sc-selector */ Check}::before {
        background: ${color('blue600')};
      }
    `}
`

const RadioButton = ({ checked }: RadioButtonProps) => (
  <RadioButtonWrapper checked={checked}>
    <RadioInput defaultChecked={checked} type='radio' />
    <Check />
  </RadioButtonWrapper>
)

export default RadioButton
